import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  TransitionContainerWrapper
} from './styled'

export class TransitionContainer extends React.PureComponent {
  render () {
    const {
      className,
      children,
      motion,
      top,
      right,
      bottom,
      left
    } = this.props

    return (
      <TransitionContainerWrapper
        className={ClassNames(
          'transition-container',
          {[`is-motion-${motion}`]: motion },
          className
        )}
        theme={{
          top,
          right,
          bottom,
          left
        }}
      >
        <div className='transition-scroll-container'>
          {children}
        </div>
      </TransitionContainerWrapper>
    )
  }

  static defaultProps = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func

    className: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ]),

    motion: PropTypes.oneOf([
      'overlap-from',
      'overlap-to'
    ])
  }
}
